/**
 * Cliente API para administrar los métodos de pago.
 *
 * La API admin vive en /api/admin/payment-methods (GET) y
 * /api/admin/payment-methods/[key] (PATCH). El backend Next.js enmascara
 * automáticamente los campos sensibles (access_token, client_secret y
 * cualquier clave dentro de extra_config cuyo nombre contenga "token" o
 * "secret"). Si al guardar mandamos el valor enmascarado tal cual, el
 * backend lo detecta (substring "••••") y conserva el valor previo.
 */

import { apiGet, apiPatch } from '../api'

export type PaymentMode = 'sandbox' | 'production'

/** Lo que devuelve el GET (con los secretos enmascarados). */
export interface PaymentMethod {
  id: string
  methodKey: string
  name: string
  description: string
  icon: string
  isActive: boolean
  mode: PaymentMode
  sortOrder: number
  publicKey: string | null
  hasAccessToken: boolean
  accessTokenMasked: string | null
  clientId: string | null
  hasClientSecret: boolean
  clientSecretMasked: string | null
  extraConfig: Record<string, unknown> | null
  updatedAt: string
}

/** Cuerpo del PATCH. Todos los campos opcionales. */
export interface PaymentMethodPatch {
  isActive?: boolean
  mode?: PaymentMode
  publicKey?: string | null
  accessToken?: string | null
  clientId?: string | null
  clientSecret?: string | null
  extraConfig?: Record<string, unknown> | null
  sortOrder?: number
}

interface ListResponse {
  data: PaymentMethod[]
}

interface PatchResponse {
  ok: boolean
  noChanges?: boolean
}

export async function listPaymentMethods(): Promise<PaymentMethod[]> {
  const r = await apiGet<ListResponse>('/api/admin/payment-methods')
  return r.data
}

export async function updatePaymentMethod(
  methodKey: string,
  patch: PaymentMethodPatch,
): Promise<PatchResponse> {
  return apiPatch<PatchResponse>(
    `/api/admin/payment-methods/${encodeURIComponent(methodKey)}`,
    patch,
  )
}
